import { todayYmd } from "../../features/cases/dates";
import { eisagLabel } from "../../features/poinika/eisaggelies";
import { formatServerDate } from "../cases/caseColumns";
import { hearingsOf } from "./poinikaData";

const HEARING_FIELDS = [
  ["court", "Δικαστήριο"],
  ["room", "Κτήριο"],
  ["aa", "Α/Α Πινακίου"],
  ["pinakio", "Πινάκιο"],
  ["gad", "ΓΑΔ"],
  ["tropos", "Τρόπος εισαγωγής"],
  ["eidos", "Διαδικασία"],
];

// Panel body for a Ποινικά entry: the ΑΒΜ details and every hearing found
// for it (the classic card shows only the first one).
const PoinikoPanelBody = ({ data }) => {
  const hearings = hearingsOf(data);
  const today = todayYmd();

  return (
    <div className="ds-detail">
      <dl className="ds-dl">
        <dt>ΑΒΜ</dt>
        <dd>{data.abm}</dd>
        <dt>Εισαγγελία</dt>
        <dd title={data.eisag}>{eisagLabel(data.eisag)}</dd>
        <dt>Σημείωση</dt>
        <dd>{data.note?.trim() || <span className="ds-muted">—</span>}</dd>
        <dt>Καταχώρηση</dt>
        <dd>{formatServerDate(data.created_at)}</dd>
      </dl>

      <h3 className="ds-detail-heading">
        Δικάσιμοι <span className="ds-muted">({hearings.length})</span>
      </h3>
      {hearings.length === 0 ? (
        <p className="ds-muted">Δεν βρέθηκαν δικάσιμοι για αυτό το ΑΒΜ.</p>
      ) : (
        <ol className="ds-hearings">
          {hearings.map((h, i) => {
            const upcoming = h.ymd && h.ymd >= today;
            return (
              <li key={`${h.date}-${h.aa}-${i}`} className={upcoming ? "is-upcoming" : ""}>
                <div className="ds-hearing-date">
                  <span className={upcoming ? "ds-date-upcoming" : ""}>{h.date || "—"}</span>
                  {h.ora && <span className="ds-muted"> · {h.ora}</span>}
                  {upcoming && <span className="ds-badge ds-badge--ok">Επερχόμενη</span>}
                </div>
                <dl className="ds-dl ds-dl--compact">
                  {HEARING_FIELDS.filter(([key]) => h[key]).map(([key, label]) => (
                    <div key={key} className="ds-dl-row">
                      <dt>{label}</dt>
                      <dd>{h[key]}</dd>
                    </div>
                  ))}
                </dl>
              </li>
            );
          })}
        </ol>
      )}
    </div>
  );
};

export default PoinikoPanelBody;
